import { CONTACT_EXISTING_KEY } from '@contact/hooks/contactsQueries';

export const getIsMatchingExistingContactsQuery = (
  queryKey: readonly unknown[],
  sourceUid: string,
) => {
  const isExistingContactsQuery = queryKey.join('').startsWith(CONTACT_EXISTING_KEY.join(''));
  const sourceUids = queryKey.at(-1);
  const hasSourceUids = Array.isArray(sourceUids) && sourceUids.length > 0;

  return isExistingContactsQuery && hasSourceUids && sourceUids.includes(sourceUid);
};
